module.exports = __webpack_public_path__ + "static/media/Cruisecontrol.ec685971.svg";